import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fill-height embed-container overflow-x-hidden"
}
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Node-RED Management", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_router_view = _resolveComponent("router-view")!

  return (!_ctx.$route.params.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_row, {
            class: "pt-2 mx-4 pb-2",
            justify: "space-between",
            align: "center",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    align: "center",
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_data_table, {
            loading: _ctx.loading,
            color: "primary",
            headers: _ctx.headers,
            items: _ctx.nodeRedInstances,
            "items-per-page": "25",
            "return-object": "",
            height: "calc(100vh - 145px)"
          }, {
            [`item.actions`]: _withCtx(({ item }) => [
              _createVNode(_component_v_btn, {
                class: "ma-1",
                width: "80",
                size: "small",
                variant: "tonal",
                color: "primary",
                to: `/admin/nodered/${item.id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Open")
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1032, ["loading", "headers", "items"])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}